import { ShieldOff, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface BaaSAccessDeniedProps {
  routePath?: string;
  label?: string;
}

/**
 * Rendered for any /baas/* route whose status is 'access_denied' in BAAS_ROUTE_SCOPES.
 * This ensures no partially-built page is ever reachable in production.
 */
export function BaaSAccessDenied({ routePath, label }: BaaSAccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-destructive/10 border border-destructive/20 flex items-center justify-center mb-4">
        <ShieldOff className="w-7 h-7 text-destructive" />
      </div>
      <h2 className="text-xl font-bold text-foreground mb-1">Access Denied</h2>
      <p className="text-sm text-muted-foreground max-w-sm mb-1">
        {label ? `The "${label}" section` : 'This section'} is not yet authorized in the BaaS portal scope matrix.
      </p>
      {routePath && (
        <p className="text-[11px] font-mono text-muted-foreground/60 mb-5">{routePath}</p>
      )}
      <Button
        variant="outline"
        size="sm"
        className="gap-1.5"
        onClick={() => navigate('/baas')}
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Back to Dashboard
      </Button>
    </div>
  );
}
